<template>
    <div>
      <el-button 
        type="primary" 
        @click="openDialog" 
        :disabled="list.length >= 3"
      >
        新增联系人
      </el-button>
  
      <!-- 联系人表格 -->
      <el-table :data="list" style="width: 100%; margin-top: 20px;">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="name" label="姓名" width="120" />
        <el-table-column prop="title" label="座右铭" width="150" />
        <el-table-column prop="department" label="联系方式" width="150" />
        <el-table-column prop="remark" label="宣言" width="400" />
        <el-table-column prop="avatar" label="头像" width="120" align="center">
          <template slot-scope="scope">
            <el-image 
              :src="getFullImageUrl(scope.row.avatar)" 
              style="width: 80px; height: 80px;" 
              fit="cover" 
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="small" @click="edit(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" @click="remove(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px; text-align: right;"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="page"
        @current-change="loadContacts"
      />
  
      <!-- 新增/编辑对话框 -->
      <el-dialog :visible.sync="showDialog" title="联系人管理" width="600px">
        <el-form :model="form" label-width="100px">
          <el-form-item label="姓名">
            <el-input v-model="form.name" />
          </el-form-item>
          <el-form-item label="座右铭">
            <el-input v-model="form.title" />
          </el-form-item>
          <el-form-item label="联系方式">
            <el-input v-model="form.department" />
          </el-form-item>
          <el-form-item label="宣言">
            <el-input type="textarea" v-model="form.remark" rows="8" />
          </el-form-item>
          <el-form-item label="头像">
            <input type="file" @change="onAvatarChange" />
            <div v-if="form.avatarPreview" style="margin-top: 10px;">
              <el-image 
                :src="form.avatarPreview" 
                style="width: 120px; height: 120px;" 
                fit="cover" 
              />
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="save">保存</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { Message } from "element-ui";
  import { getContactList, addContact, updateContact, deleteContact } from "@/api/contact.js";
  
  export default {
    name: "Contact",
    data() {
      return {
        list: [],
        total: 0,
        page: 1,
        pageSize: 5,
        showDialog: false,
        form: {
          id: null,
          name: "",
          title: "",
          department: "",
          remark: "",
          avatarFile: null,     // 上传文件对象
          avatarPreview: null   // 预览图片
        }
      };
    },
    created() {
      this.loadContacts();
    },
    methods: {
      async loadContacts() {
        try {
          const res = await getContactList({ page: this.page, pageSize: this.pageSize });
          if (res.status === 200) {
            this.list = res.data.data || [];
            this.total = this.list.length;
          } else {
            Message.error(res.msg || "获取联系人列表失败");
          }
        } catch (err) {
          Message.error("请求异常");
        }
      },
  
      openDialog() {
        if (this.list.length >= 3) {
          Message.warning("最多只能有三位联系人");
          return;
        }
        this.resetForm();
        this.showDialog = true;
      },
  
      edit(row) {
        this.form = {
          id: row.id,
          name: row.name,
          title: row.title,
          department: row.department,
          remark: row.remark,
          avatarFile: null,
          avatarPreview: this.getFullImageUrl(row.avatar)
        };
        this.showDialog = true;
      },
  
      closeDialog() {
        this.resetForm();
        this.showDialog = false;
      },
  
      onAvatarChange(e) {
        const file = e.target.files[0];
        if (file) {
          this.form.avatarFile = file;
          this.form.avatarPreview = URL.createObjectURL(file);
        }
      },
  
      async save() {
        try {
          const formData = new FormData();
          formData.append("name", this.form.name);
          formData.append("title", this.form.title);
          formData.append("department", this.form.department);
          formData.append("remark", this.form.remark);
          if (this.form.avatarFile) {
            formData.append("avatar", this.form.avatarFile);
          }
  
          let res;
          if (this.form.id) {
            formData.append("id", this.form.id);
            res = await updateContact(formData);
          } else {
            res = await addContact(formData);
          }
  
          if (res.status === 200) {
            Message.success("保存成功");
            this.showDialog = false;
            this.loadContacts();
          } else {
            Message.error(res.msg || "保存失败");
          }
        } catch (err) {
          Message.error("请求异常");
        }
      },
  
      async remove(id) {
        try {
          const res = await deleteContact({ id });
          if (res.status === 200) {
            Message.success("删除成功");
            this.loadContacts();
          } else {
            Message.error(res.msg || "删除失败");
          }
        } catch (err) {
          Message.error("请求异常");
        }
      },
  
      resetForm() {
        this.form = {
          id: null,
          name: "",
          title: "",
          department: "",
          remark: "",
          avatarFile: null,
          avatarPreview: null
        };
      },
  
      getFullImageUrl(path) {
        return path ? (path.startsWith("http") ? path : this.$serverUrl + path) : "";
      }
    }
  };
  </script>
  